import React from 'react';
import Navbar from '../components/Navbar';
import '../css/faq.css';

const Faq = () => {
	return (
        <div className="bodystyle">
            <div id="everything">
                <Navbar />

				<div className="faq-content">
				  <div className="faq-question">
					<input id="q1" type="checkbox" className="panel"></input>
					<label for="q1" className="plussign">+</label>
					<label for="q1" className="panel-title">What initial conditions do you use?</label>
					<div className="panel-content">We started with GFS initial conditions, which may result in some performance degradation compared to the more natural ERA5 or IFS initial conditions. We now offer IFS initialized versions for comparison.</div>
				  </div>
				  
				  <div className="faq-question">
					<input id="q2" type="checkbox" className="panel"></input>
					<label for="q2" className="plussign">+</label>
					<label for="q2" className="panel-title">Is the raw data available?</label>
					<div className="panel-content">We have an s3 bucket with NetCDF4 output <a href="https://noaa-oar-mlwp-data.s3.amazonaws.com/index.html" target="_blank" rel="noreferrer">here</a>.</div>
				  </div>
				  
				  <div className="faq-question">
					<input id="q3" type="checkbox" className="panel"></input>
					<label for="q3" className="plussign">+</label>
					<label for="q3" className="panel-title">Do you have a Github repo to run models with GFS initial conditions?</label>
					<div className="panel-content">Coming soon!</div>
				  </div>

                  <div className="faq-question">
                    <input id="q4" type="checkbox" className="panel"></input>
                    <label for="q4" className="plussign">+</label>
                    <label for="q4" className="panel-title">Can you increase the contour intervals?</label>
                    <div className="panel-content">Currently contour levels are fixed, but customizable levels are a feature we'll try to add in time.
</div>
                  </div>

                  <div className="faq-question">
                    <input id="q5" type="checkbox" className="panel"></input>
                    <label for="q5" className="plussign">+</label>
                    <label for="q5" className="panel-title">Can you output <i>variable</i>?</label>
                    <div className="panel-content">We currently offer most of the variables that the AI models produce. There are a few pressure levels that we skipped to save processing time - if these would be useful to you, contact us and let us know.</div>
                  </div>

                  <div className="faq-question">
                    <input id="q6" type="checkbox" className="panel"></input>
                    <label for="q6" className="plussign">+</label>
                    <label for="q6" className="panel-title">Can you add my model to your site?</label>
                    <div className="panel-content">Maybe! If you have a peer-reviewed weather model, contact us and we'll look into it.</div>
                  </div>

				</div>
			</div>
		</div>
	);
};

export default Faq;

